export default __webpack_public_path__ + "static/media/Logo.886d69e4.svg";